import { dinero, Dinero } from "dinero.js";
import { AUD } from "@dinero.js/currencies";

export const dineroAUD = (amount: number, scale?: number): Dinero<number> =>
  dinero({
    amount,
    scale,
    currency: AUD
  });
